export enum Browser {
  Firefox,
}
